import React, { useEffect, useState, useRef } from "react";
import { Modal, Button, Form, Row, Col, Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { SettingsOutlined } from "@material-ui/icons";
import { find } from "lodash";
import CountrySelect from "../CountrySelect";
import { displayNotification } from "../../store/actions/notificationActions";
import { updateDomain } from "../../store/actions/domainActions";
import AllowedForRole from "../Users/AllowedForRole";
import LCButton from "../styles/LCButton";

const ActivitySettingsModal = ({ domain, type = "primary" }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.config.disableButton);
  const currentDomain = domain; //useSelector((state) => state.domains.currentDomain);
  const domains = useSelector((state) => state.domains.domains);
  const [updateDomainForm] = Form.useForm();
  const emailsRef = useRef(null);

  useEffect(() => {
    if (domains.length > 0) {
      const findDomain = find(domains, (domain) => {
        return currentDomain._id === domain._id;
      });
      if (findDomain) {
        updateDomainForm.setFieldsValue({
          allowedCountries: findDomain.allowedSessionCountries,
          disallowedCountries: findDomain.disallowedSessionCountries,
          emails: findDomain.sharedWith,
        });
      }
    }
  }, [isModalVisible]);

  const showModal = () => {
    setIsModalVisible(true);
    updateDomainForm.resetFields();
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const onFinish = (values) => {
    dispatch(updateDomain(currentDomain, values, setIsModalVisible));
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const copyTrackingCode = () => {
    navigator.clipboard.writeText(
      `<script src="${process.env.recorderURL}" defer></script>`
    );
    dispatch(
      displayNotification({ type: "success", message: "Tracking code copied!" })
    );
  };

  const handleChange = (value) => {
    emailsRef.current.blur();
  };

  const validEmails = (rule, value, callback) => {
    let error = false;
    const emailRegex =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (value.length > 0) {
      value.forEach((email) => {
        if (!emailRegex.test(String(email).toLowerCase())) {
          error = true;
        }
      });
    }
    if (error) {
      callback("Please add valid email addresses.");
    } else {
      callback();
    }
  };

  return (
    <>
      <LCButton type="secondary" addMargin as="button" onClick={showModal}>
        Settings <SettingsOutlined />
      </LCButton>
      <Modal
        title={`Settings for ${currentDomain.name}`}
        visible={isModalVisible}
        onOk={() => updateDomainForm.submit()}
        onCancel={handleCancel}
        okText="Update"
        keyboard={false}
        maskClosable={false}
        width={750}
        okButtonProps={{
          loading: isLoading,
        }}
        footer={[
          <LCButton
            type="primary"
            addMargin
            as="button"
            onClick={() => handleCancel()}
          >
            Cancel
          </LCButton>,
          <LCButton
            type="secondary"
            addMargin
            as="button"
            onClick={() => updateDomainForm.submit()}
          >
            Save
          </LCButton>,
        ]}
      >
        <Row className="mb-4">
          <h4>Tracking Code</h4>
          <Col className="tracker-script-code" span={20}>
            &lt;script async src="
            {`${process.env.recorderURL}`}
            "&gt;&lt;/script&gt;
          </Col>
          <Col
            style={{ textAlign: "right" }}
            onClick={() => copyTrackingCode()}
            span={4}
          >
            <LCButton type="primary" as="button">
              Copy
            </LCButton>
          </Col>
        </Row>
        <Form
          form={updateDomainForm}
          name="updateDomain"
          layout="vertical"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <Form.Item
            label="Allowed Countries (If empty tracks all countries)"
            name="allowedCountries"
            className="mb-1"
          >
            <CountrySelect name="allowedCountries" />
          </Form.Item>
          <h4 className="mt-2 mb-2" style={{ textAlign: "center" }}>
            OR
          </h4>
          <Form.Item
            label="Disallowed Countries (If empty tracks all countries)"
            name="disallowedCountries"
            className="mb-1"
          >
            <CountrySelect name="disallowedCountries" />
          </Form.Item>
          <AllowedForRole roles={["admin"]}>
            <Form.Item
              label="Shared With"
              name="emails"
              className="mb-1"
              rules={[
                {
                  validator: validEmails,
                },
              ]}
            >
              <Select
                mode="tags"
                placeholder="Add emails to share this domain..."
                allowClear
                ref={emailsRef}
                name="emails"
                onChange={handleChange}
              ></Select>
            </Form.Item>
          </AllowedForRole>
        </Form>
      </Modal>
    </>
  );
};

export default ActivitySettingsModal;
